export const app_on_off_tr = {
  true: 'Açık',
  false: 'Kapalı',
};
